export type FaqRowVariant = "plain" | "inset" | "article";

export const FAQ_ROW_STYLES: Record<
  FaqRowVariant,
  { row: string; summary: string; body: string }
> = {
  plain: {
    row: "",
    summary: "py-4 text-sm font-medium hover:underline",
    body: "pb-4 text-sm leading-relaxed text-muted-foreground",
  },
  inset: {
    row: "",
    summary:
      "min-h-11 px-4 py-3 text-sm font-medium text-foreground transition-colors hover:bg-muted",
    body: "px-4 pb-4 text-sm leading-relaxed text-muted-foreground",
  },
  article: {
    row: "",
    summary:
      "px-5 py-4 text-base font-semibold text-foreground transition-colors hover:text-action",
    body: "space-y-3 px-5 pb-4 text-[0.95rem] leading-relaxed text-muted-foreground [&>p]:m-0 [&_a]:text-brand-strong [&_a]:underline [&_a]:underline-offset-2",
  },
};

export const FAQ_SUMMARY_BASE =
  "flex w-full cursor-pointer list-none items-center justify-between gap-4 text-left [&::-webkit-details-marker]:hidden";
